import React from 'react';
import {
  Building2, User, Pill, Mail, ListOrdered, BarChart3, Bell, Phone, Target,
  FlaskConical, Pencil, Trash2, X, ArrowLeft, AlertTriangle, FileText, Package
} from 'lucide-react';

const GREEN = '#008066';
const SW = 2;

const OBJECT_MAP = {
  company: Building2,
  person: User,
  product: Pill,
  email_order: Mail,
  order_line: ListOrdered,
  stock_forecast: BarChart3,
  notification: Bell,
  phone_interaction: Phone,
  opportunity: Target
};

const ACTION_MAP = {
  edit: Pencil,
  delete: Trash2,
  close: X,
  back: ArrowLeft,
  warn: AlertTriangle,
  cockpit: FlaskConical,
  package: Package
};

/** Icone de um objeto CRM (por name_singular) */
export const objectIcon = (name, size = 18) => {
  const I = OBJECT_MAP[name] || FileText;
  return <I size={size} color={GREEN} strokeWidth={SW} />;
};

/** Icone do Cockpit */
export const cockpitIcon = (size = 18) => <FlaskConical size={size} color={GREEN} strokeWidth={SW} />;

/** Icone de acao (edit/delete/close/back/warn) */
export const actionIcon = (name, size = 16) => {
  const I = ACTION_MAP[name];
  return I ? <I size={size} color={GREEN} strokeWidth={SW} /> : null;
};
